import type { AreaValueDataObject } from 'ComponentLibrary/src/common/area'
import type { MoneyPerAreaValue } from 'ComponentLibrary/src/common/money'

export type LeadingValuePerSqmLabels = {
    valuePerSquareMeter: string
    valuePerSquareMeterGfa: string
    valuePerSquareMeterLand: string
    rentableArea: string
    grossFloorArea: string
    landArea: string
}

export type LeadingValuePerSqmValuation = {
    selected_valuation_methods: string[]
    market_value_per_rentable_area?: MoneyPerAreaValue
    market_value_per_gross_floor_area?: MoneyPerAreaValue
    market_value_per_land_area?: MoneyPerAreaValue
    rentable_area?: AreaValueDataObject
    gross_floor_area?: AreaValueDataObject
    land_area?: AreaValueDataObject
}

export function getLeadingValuePerSqm(valuation: LeadingValuePerSqmValuation, labels: LeadingValuePerSqmLabels) {
    if (
        valuation.selected_valuation_methods.includes('income') ||
        valuation.selected_valuation_methods.includes('investment_method') ||
        valuation.selected_valuation_methods.includes('discounted_cashflow')
    ) {
        return {
            valuePerSqmLabel: labels.valuePerSquareMeter,
            valuePerSqmValue: valuation.market_value_per_rentable_area,
            areaLabel: labels.rentableArea,
            areaValue: valuation.rentable_area,
        }
    }
    if (valuation.selected_valuation_methods.includes('cost') || valuation.selected_valuation_methods.includes('comparison')) {
        return {
            valuePerSqmLabel: labels.valuePerSquareMeterGfa,
            valuePerSqmValue: valuation.market_value_per_gross_floor_area,
            areaLabel: labels.grossFloorArea,
            areaValue: valuation.gross_floor_area,
        }
    }
    if (valuation.selected_valuation_methods.includes('land_value')) {
        return {
            valuePerSqmLabel: labels.valuePerSquareMeterLand,
            valuePerSqmValue: valuation.market_value_per_land_area,
            areaLabel: labels.landArea,
            areaValue: valuation.land_area,
        }
    }
    return {
        valuePerSqmLabel: labels.valuePerSquareMeter,
        valuePerSqmValue: undefined,
        areaLabel: labels.landArea,
        areaValue: undefined,
    }
}
